import type { StationVolumesLayerMeta } from './types';

/**
 * A derived layer's station-volumes block, wherever the run wrote it:
 * `metadata.stationVolumes` (both analyses, spec §10.3 on), else the nested
 * surface-difference key older surface-difference runs used.
 */
export function stationVolumesMetaOf(metadata: unknown): StationVolumesLayerMeta | null {
  const m = metadata as {
    stationVolumes?: StationVolumesLayerMeta | null;
    surfaceDifference?: { stationVolumes?: StationVolumesLayerMeta | null } | null;
  } | null;
  return m?.stationVolumes ?? m?.surfaceDifference?.stationVolumes ?? null;
}

export function hasStationVolumesMeta(metadata: unknown): boolean {
  return stationVolumesMetaOf(metadata) !== null;
}
